define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "",

        validation: {
            mt4_account_no:{
                required: true,
                min: 10000
            }
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/forms/competition/ranking_form.js
// module id = 28
// module chunks = 0